export const EventOrderStatuses = {
    PAID: 'paid',
    PENDING: 'pending',
    REJECTED: 'rejected',
    PARTIAL_REFUND: 'partial-refund',
    REFUNDED: 'refunded',
    LATE_ORDERS: 'lateOrders',
    CANCELlATION_WITHOUT_REFUND: 'cancellation_without_refund',
    DIVIDE_ORDER_PENDING: "divide_order_pending",
    DIVIDE_ORDER_ACTIVE: "divide_order_active",
    DIVIDE_ORDER_COMPLETE: "divide_order_complete",
    DIVIDE_ORDER_FAILED: "divide_order_failed"
}

export const CouponTypes = {
    FIXED: 'fixed',
    PERCENTAGE: 'percentage',
    CUSTOM_PRICE: "customPrice",
}

export const AppEnv = {
    PROD: 'live',
    STAGING: 'staging',
    LOCAL: 'local',
}

export const LinksUtm = {
    PRIMARY: "PRIMARY"
}

export const IncUtmActionTypes = {
    UNIQUE_VIEWS: "UNIQUE_VIEWS",
    VIEWS: "VIEWS",
    CLICKS: "CLICKS"
}

export const CollaboratesRoles = {
    SCANNER: "scanner",
    READER: "reader",
    TRAINER: "trainer",
    EDITOR: "editor",
    ADMIN: "admin",
    PROMOTER: "promoter",
    CASHIER: "cashier",
}

export const AuthTypes = {
    LOGIN: 'login',
    REGISTER: 'register',
}

export const GeneralFieldsName = {
    B_DAY: 'birthday',
    L_NAME: 'lname',
    F_NAME: 'fname',
    EMAIL: 'email',
    PHONE: 'phone',
    GENDER: 'gender',
    SOCIAL_LINK: 'socialLink',
    EMAIL_MARKETING: 'isAllowMarketingDelivery',
    BUSINESS_CODE: 'businessCode', // מספר חברה (ח.פ.)
    BUSINESS_NAME: 'businessName', // שם חברה
}

/**
 * User Event Fields - Actual field names used in form data and API payloads
 * These are the keys used when submitting user/attendee information in order forms
 * Reuses GeneralFieldsName values where they match, overrides where different
 * Note: Different from GeneralFieldsName which represents backend configuration field identifiers
 */
export const UserEventFields = {
    FIRST_NAME: GeneralFieldsName.F_NAME,           // 'fname'
    LAST_NAME: GeneralFieldsName.L_NAME,            // 'lname'
    PHONE: GeneralFieldsName.PHONE,                 // 'phone'
    EMAIL: GeneralFieldsName.EMAIL,                 // 'email'
    BIRTH_DATE: 'birth_date',                       // Different from B_DAY ('birthday')
    GENDER: GeneralFieldsName.GENDER,               // 'gender'
    SOCIAL_LINK: 'social_link',                     // Different from SOCIAL_LINK ('socialLink')
    BUSINESS_CODE: GeneralFieldsName.BUSINESS_CODE, // 'businessCode'
    BUSINESS_NAME: GeneralFieldsName.BUSINESS_NAME, // 'businessName'
}

export const FieldsTypes = {
    DATE_NO_TIME: 'date_no_time',
    STRING: 'string',
    YES_OR_NO: 'boolean',
    CHECKBOX: 'checkbox',
    // For business fields, use STRING type
    BUSINESS_CODE: 'string',
    BUSINESS_NAME: 'string',
}

export const PaymeFileTypes = {
    SOCIAL_ID: 1,
    BANK_ACCOUNT_OWNERSHIP: 2,
    CORPORATE_CERTIFICATE: 3
}

export const PAYME_HOSTED_FIELDS_SCRIPT_URL = 'https://cdn.payme.io/hf/v1/hostedfields.js'

export const FeeCollectionTypes = {
    PERCENTAGE_FROM_TICKET: "percentage_from_ticket",
    ON_TOP_OF_TICKET: "on_top_of_ticket"
}

export const SocialNetworks = {
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    LINKEDIN: 'linkedin',
    TWITTER: 'twitter',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    WHATSAPP: 'whatsapp',
    TELEGRAM: 'telegram',
}

export const SocialNetworkLabels = {
    [SocialNetworks.FACEBOOK]: 'Facebook',
    [SocialNetworks.INSTAGRAM]: 'Instagram',
    [SocialNetworks.LINKEDIN]: 'LinkedIn',
    [SocialNetworks.TWITTER]: 'Twitter',
    [SocialNetworks.TIKTOK]: 'TikTok',
    [SocialNetworks.YOUTUBE]: 'YouTube',
    [SocialNetworks.WHATSAPP]: 'WhatsApp',
    [SocialNetworks.TELEGRAM]: 'Telegram',
}

export const IEventTypeEnum = {
    TRANCE_PARTY: 'trance-party',
    TECHNO_PARTY: 'techno-party',
    ELECTRONIC_PARTY: 'electronic-party',
    CULTURE: 'culture',
    SPORT: 'sport',
    BUSINESS: 'business',
    LECTURER: 'lecturer',
    EDUCATION: 'education',
    CHARITY: 'charity',
    OTHER: 'other',
    WELLNESS: 'wellness',
    MUSIC: 'music'
};

export const SellerPageEventFilterUIElements = {
    DROPDOWN: 'dropdown',
    TABS: 'tabs',
    BUTTONS: 'buttons',
    BUTTON_GROUP: 'button-group',
};

export const SellerPageEventFilterUIElementLabels = {
    [SellerPageEventFilterUIElements.DROPDOWN]: 'dropdown',
    [SellerPageEventFilterUIElements.TABS]: 'tabs',
    [SellerPageEventFilterUIElements.BUTTONS]: 'buttons',
    [SellerPageEventFilterUIElements.BUTTON_GROUP]: 'button-group',
};

export const isValidSellerPageEventFilterUIElement = (value) => {
    return Object.values(SellerPageEventFilterUIElements).includes(value);
};

export const getUIElementType = (uiElement) => {
    switch (uiElement) {
        case SellerPageEventFilterUIElements.TABS:
            return 'tabs';
        case SellerPageEventFilterUIElements.BUTTONS:
            return 'buttons';
        case SellerPageEventFilterUIElements.BUTTON_GROUP:
            return 'button-group';
        case SellerPageEventFilterUIElements.DROPDOWN:
        default:
            return 'dropdown';
    }
};
